module.exports = __webpack_public_path__ + "img/notNearIconGrey.34688611.svg";